"use strict";
/**
* Auto-generated file from https://git.perkbox.io/perkbox-services/auth/feature-flags
* See https://git.perkbox.io/perkbox-services/auth/feature-flags/-/blob/master/public/feature_flags.go
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAdminFeatureFlags = exports.RoleFeatureFlags = exports.BusinessFeatureFlags = exports.TeamFeatureFlags = void 0;
var TeamFeatureFlags;
(function (TeamFeatureFlags) {
    TeamFeatureFlags["PerksEnabledForTeam"] = "xs:perks:team_enabled";
    TeamFeatureFlags["PerksCardlinkedEnabledForTeam"] = "xs:perks:team_cardlinked";
    TeamFeatureFlags["PerksGeoEnabledForTeam"] = "xs:perks:team_geo";
    TeamFeatureFlags["InsightsEnabledForTeam"] = "xs:ins:team_enabled";
    TeamFeatureFlags["RnREnabledForTeam"] = "xs:rnr:team_enabled";
    TeamFeatureFlags["MedicalEnabledForTeam"] = "xs:med:team_enabled";
    TeamFeatureFlags["TenantWalletEnabledForTeam"] = "xs:twallet:team_enabled";
    TeamFeatureFlags["UserWalletEnabledForTeam"] = "xs:uwallet:team_enabled";
    TeamFeatureFlags["CultureHubEnabledForTeam"] = "xs:culturehub:team_enabled";
    TeamFeatureFlags["PaymentsZipDisabled"] = "PaymentsZipDisabled";
    TeamFeatureFlags["WellnessHub"] = "WellnessHub";
    TeamFeatureFlags["GlobalBeta"] = "GlobalBeta";
    TeamFeatureFlags["WorkOSFullAccess"] = "WorkOSFullAccess";
    TeamFeatureFlags["ReportingAdminDashboardFullAccess"] = "ReportingAdminDashboardFullAccess";
    TeamFeatureFlags["AnnualLeavePurchase"] = "AnnualLeavePurchase";
    TeamFeatureFlags["AnnualLeavePurchaseShow"] = "AnnualLeavePurchaseShow";
    TeamFeatureFlags["HomeElectronics"] = "HomeElectronics";
    TeamFeatureFlags["HomeElectronicsShow"] = "HomeElectronicsShow";
    TeamFeatureFlags["HomeElectronicsHidden"] = "HomeElectronicsHidden";
    TeamFeatureFlags["CycleToWork"] = "CycleToWork";
    TeamFeatureFlags["CycleToWorkShow"] = "CycleToWorkShow";
    TeamFeatureFlags["CycleToWorkHidden"] = "CycleToWorkHidden";
    TeamFeatureFlags["MedicalHealthHero"] = "MedicalHealthHero";
    TeamFeatureFlags["HideCashback"] = "HideCashback";
    TeamFeatureFlags["PayrollGiving"] = "PayrollGiving";
    TeamFeatureFlags["PayrollGivingShow"] = "PayrollGivingShow";
    TeamFeatureFlags["SalaryFinance"] = "SalaryFinance";
    TeamFeatureFlags["SalaryFinanceShow"] = "SalaryFinanceShow";
    TeamFeatureFlags["CarScheme"] = "CarScheme";
    TeamFeatureFlags["CarSchemeShow"] = "CarSchemeShow";
    TeamFeatureFlags["HealthCashPlan"] = "HealthCashPlan";
    TeamFeatureFlags["HealthCashPlanShow"] = "HealthCashPlanShow";
    TeamFeatureFlags["GymMembership"] = "GymMembership";
    TeamFeatureFlags["GymMembershipShow"] = "GymMembershipShow";
    TeamFeatureFlags["PensionAdvantage"] = "PensionAdvantage";
    TeamFeatureFlags["PensionAdvantageShow"] = "PensionAdvantageShow";
    TeamFeatureFlags["TravelAndLeisure"] = "TravelAndLeisure";
    TeamFeatureFlags["TravelAndLeisureShow"] = "TravelAndLeisureShow";
    TeamFeatureFlags["EAP"] = "EAP";
    TeamFeatureFlags["EAPHidden"] = "EAPHidden";
})(TeamFeatureFlags || (exports.TeamFeatureFlags = TeamFeatureFlags = {}));
var BusinessFeatureFlags;
(function (BusinessFeatureFlags) {
    BusinessFeatureFlags["RecognitionHidden"] = "RecognitionHidden";
    BusinessFeatureFlags["WellnessHidden"] = "WellnessHidden";
    BusinessFeatureFlags["FlexiRewardsHidden"] = "FlexiRewardsHidden";
    BusinessFeatureFlags["MerchandiseHidden"] = "MerchandiseHidden";
    BusinessFeatureFlags["ReportingBetaAccess"] = "ReportingBetaAccess";
    BusinessFeatureFlags["ContentCards"] = "ContentCards";
    BusinessFeatureFlags["HomepageLanesHidden"] = "HomepageLanesHidden";
    BusinessFeatureFlags["DirectorySyncAccess"] = "DirectorySyncAccess";
    BusinessFeatureFlags["SingleSignOnAccess"] = "SingleSignOnAccess";
    BusinessFeatureFlags["CustomRewards"] = "CustomRewards";
    BusinessFeatureFlags["EnableFileUploadTab"] = "EnableFileUploadTab";
    BusinessFeatureFlags["CultureHubFileUploadHidden"] = "CultureHubFileUploadHidden";
    BusinessFeatureFlags["FriendsAndFamilyOff"] = "FriendsAndFamilyOff";
    BusinessFeatureFlags["CultureHubHidden"] = "CultureHubHidden";
    BusinessFeatureFlags["LocalBenefits"] = "LocalBenefits";
})(BusinessFeatureFlags || (exports.BusinessFeatureFlags = BusinessFeatureFlags = {}));
var RoleFeatureFlags;
(function (RoleFeatureFlags) {
    RoleFeatureFlags["GlobalAdminFlag"] = "xs:global_admin";
    RoleFeatureFlags["CoreTeamsSelfBusinessFullAccess"] = "CoreTeamsSelfBusinessFullAccess";
    RoleFeatureFlags["CoreBusinessSelfBusinessModify"] = "CoreBusinessSelfBusinessModify";
    RoleFeatureFlags["CoreUsersSelfBusinessFullAccess"] = "CoreUsersSelfBusinessFullAccess";
    RoleFeatureFlags["CoreUsersSelfBusinessModifyOnly"] = "CoreUsersSelfBusinessModifyOnly";
    RoleFeatureFlags["OnboardingBusinessSelfBusinessFullAccess"] = "OnboardingBusinessSelfBusinessFullAccess";
    RoleFeatureFlags["ReportingSelfBusinessFullAccess"] = "ReportingSelfBusinessFullAccess";
    RoleFeatureFlags["RecognitionSelfBusinessFullAccess"] = "RecognitionSelfBusinessFullAccess";
    RoleFeatureFlags["PayRollPayOrderApproval"] = "PayRollPayOrderApproval";
})(RoleFeatureFlags || (exports.RoleFeatureFlags = RoleFeatureFlags = {}));
var IAdminFeatureFlags;
(function (IAdminFeatureFlags) {
    IAdminFeatureFlags["AuthGhost"] = "AuthGhost";
    IAdminFeatureFlags["AuthIAdminCanGDPRUsers"] = "AuthIAdminCanGDPRUsers";
    IAdminFeatureFlags["AuthIAdminEngineering"] = "AuthIAdminEngineering";
    IAdminFeatureFlags["AuthIAdminReadOnly"] = "AuthIAdminReadOnly";
    IAdminFeatureFlags["AuthManageSessionsAndDevices"] = "AuthManageSessionsAndDevices";
    IAdminFeatureFlags["AuthMFAManage"] = "AuthMFAManage";
    IAdminFeatureFlags["ChannelPartnerFullAccess"] = "ChannelPartnerFullAccess";
    IAdminFeatureFlags["CoreBusinessFullAccess"] = "CoreBusinessFullAccess";
    IAdminFeatureFlags["CoreGroupsFullAccess"] = "CoreGroupsFullAccess";
    IAdminFeatureFlags["CoreUsersFullAccess"] = "CoreUsersFullAccess";
    IAdminFeatureFlags["FlexiRewardsFullAccess"] = "FlexiRewardsFullAccess";
    IAdminFeatureFlags["GodModeFlag"] = "GodModeFlag";
    IAdminFeatureFlags["InsightsFullAccess"] = "InsightsFullAccess";
    IAdminFeatureFlags["ManagePaymentsCHAccess"] = "ManagePaymentsCHAccess";
    IAdminFeatureFlags["ManagePaymentsFullAccess"] = "ManagePaymentsFullAccess";
    IAdminFeatureFlags["ManageStockFullAccess"] = "ManageStockFullAccess";
    IAdminFeatureFlags["ManageStockReadOnly"] = "ManageStockReadOnly";
    IAdminFeatureFlags["MedicalFullAccess"] = "MedicalFullAccess";
    IAdminFeatureFlags["OnboardingBusinessFullAccess"] = "OnboardingBusinessFullAccess";
    IAdminFeatureFlags["OnboardingUserFullAccess"] = "OnboardingUserFullAccess";
    IAdminFeatureFlags["OpenApiFullAccess"] = "OpenApiFullAccess";
    IAdminFeatureFlags["PerksFullAccess"] = "PerksFullAccess";
    IAdminFeatureFlags["RegionsFullAccess"] = "RegionsFullAccess";
    IAdminFeatureFlags["ReportingFullAccess"] = "ReportingFullAccess";
    IAdminFeatureFlags["RnRFullAccess"] = "RnRFullAccess";
    IAdminFeatureFlags["TenantWalletFullAccess"] = "TenantWalletFullAccess";
    IAdminFeatureFlags["V4RedemptionFullAccess"] = "V4RedemptionFullAccess";
    IAdminFeatureFlags["WorkOSFullAccess"] = "WorkOSFullAccess";
    IAdminFeatureFlags["ZuoraProductMappingsFullAccess"] = "ZuoraProductMappingsFullAccess";
    IAdminFeatureFlags["DealDiscountsFullAccess"] = "DealDiscountsFullAccess";
})(IAdminFeatureFlags || (exports.IAdminFeatureFlags = IAdminFeatureFlags = {}));
var FeatureFlags = __assign(__assign(__assign(__assign({}, TeamFeatureFlags), BusinessFeatureFlags), RoleFeatureFlags), IAdminFeatureFlags);
exports.default = FeatureFlags;
